import { IDmLoaiChungChiChungNhan } from "../../../model/response/category/IDmLoaiChungChiChungNhan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLoaiChungChiChungNhanActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDmLoaiChungChiChungNhan[], // Replace with the actual type if known
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDmLoaiChungChiChungNhan | undefined, // Replace with the actual type if known
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDmLoaiChungChiChungNhan, // Replace with the actual type if known
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eLoaiChungChiChungNhanActionIds = generateActionTypeIds(eLoaiChungChiChungNhanActionsObj, "LOAI_CHUNG_CHI_CHUNG_NHAN");
export type ILoaiChungChiChungNhanActionTypes = IGenericActionType<typeof eLoaiChungChiChungNhanActionsObj, "LOAI_CHUNG_CHI_CHUNG_NHAN">;